import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propStr } from '../../../helpers/custom-prop-types';
import FileExcelIcon from './FileExcelIcon';
import FilePdfIcon from './FilePdfIcon';
import FilePptxIcon from './FilePptxIcon';
import FileTextIcon from './FileTextIcon';
import FileWordIcon from './FileWordIcon';
/**
 * ファイル拡張子に対応したアイコンを返す
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const FileWrapperIcon = (props) => {
    const { className, extension: rawExtension } = props;
    const extension = useMemo(() => (rawExtension || '').toLowerCase(), [rawExtension]);
    if (['pptx', 'ppt'].includes(extension)) {
        return _jsx(FilePptxIcon, { className: className });
    }
    if (['xlsx', 'xls'].includes(extension)) {
        return _jsx(FileExcelIcon, { className: className });
    }
    if (['docx', 'doc'].includes(extension)) {
        return _jsx(FileWordIcon, { className: className });
    }
    if (['pdf'].includes(extension)) {
        return _jsx(FilePdfIcon, { className: className });
    }
    return _jsx(FileTextIcon, { className: className });
};
FileWrapperIcon.propTypes = {
    className: propStr(),
    extension: propStr(),
};
FileWrapperIcon.defaultProps = {
    className: '',
    extension: '',
};
export default FileWrapperIcon;
